// Registry of integer-coded enum fields. Keys are `<Model>.<field>`. Values
// are arrays of i18n keys indexed by the integer value (so position 0 is the
// label for value 0, etc.). When the audit log encounters one of these
// fields, the EventDiff component looks up the human label instead of
// rendering the raw integer.
//
// Add new entries here when a new enum-like integer column should display a
// reader-friendly name in the audit log.

import type { TFunction } from "i18next"

const ENUM_KEYS: Record<string, string[]> = {
    "Employee.group": [
        "employees.groups.none",
        "employees.groups.administrative",
        "employees.groups.operations",
    ],
    "Employee.department": [
        "employees.departments.none",
        "employees.departments.administration",
        "employees.departments.production",
    ],
    "Employee.position": [
        "employees.positions.none",
        "employees.positions.generalManager",
        "employees.positions.administrativeAssistant",
        "employees.positions.operationsSupervisor",
        "employees.positions.extruderOperator",
        "employees.positions.flexoOperator",
        "employees.positions.cutOperator",
        "employees.positions.concierge",
        "employees.positions.operator",
        "employees.positions.receptionist",
    ],
}

export function hasEnumLabel(model: string, field: string): boolean {
    return `${model}.${field}` in ENUM_KEYS
}

export function enumLabel(t: TFunction, model: string, field: string, value: unknown): string | null {
    const keys = ENUM_KEYS[`${model}.${field}`]
    if (!keys) return null
    if (typeof value !== "number") return null
    const key = keys[value]
    if (!key) return null
    return t(key)
}
